

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const REQUESTAPPRAISALREAPPLY= createAsyncThunk(
  "requestAppraisalReapply/requestAppraisalReapply",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const requestAppraisalReapplySlice = createSlice({
  name: "requestAppraisalReapplySlice",
  initialState: {
    requestAppraisalReapply: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfrequestAppraisalReapply: (state) => {
        state.requestAppraisalReapply.loading = false
        state.requestAppraisalReapply.error = false
        state.requestAppraisalReapply.data = []
        state.requestAppraisalReapply.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(REQUESTAPPRAISALREAPPLY.fulfilled, (state, action) => {
      state.requestAppraisalReapply = {
        ...state.requestAppraisalReapply,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(REQUESTAPPRAISALREAPPLY.pending, (state, action) => {
      state.requestAppraisalReapply = {
        ...state.requestAppraisalReapply,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(REQUESTAPPRAISALREAPPLY.rejected, (state, action) => {
      state.requestAppraisalReapply = {
        ...state.requestAppraisalReapply,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const requestAppraisalReapplyAction = {
    REQUESTAPPRAISALREAPPLY,
};

export { requestAppraisalReapplyAction };
export default requestAppraisalReapplySlice.reducer;
export const {setInitialStateOfrequestAppraisalReapply} = requestAppraisalReapplySlice.actions
